import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-device",
  "use": "app-icon-device-usage",
  "viewBox": "0 0 50 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 30\" id=\"app-icon-device\"><g stroke=\"#3D3E52\" fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#35C59E\" stroke-linejoin=\"round\" d=\"M37.766 27.963H1V11.37L37.766 1zM49 29l-11.234-1.037V1L49 7.222z\" /><path d=\"M1.422 21.363c4.348-2.027 9.19-3.51 14.526-4.453 5.336-.943 12.462-1.346 21.377-1.211\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol